import { render } from "./EditLabelGroup.vue?vue&type=template&id=5cd9f846"
import script from "./EditLabelGroup.vue?vue&type=script&lang=js"
export * from "./EditLabelGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__